import React, { useEffect } from 'react';
import { useLogin } from '../../../../hooks/useLogin';
import { ApiTokenType } from '../../../../context/AuthContext';

type Props = {
  apiToken: string;
};

const LoginWithApiToken: React.FC<Props> = ({ apiToken }) => {
  const login = useLogin();

  useEffect(() => {
    login(apiToken, ApiTokenType.LEGACY);
  }, [login, apiToken]);

  return <></>;
};

export default LoginWithApiToken;
